export const RECENT_STORES_START = 'RECENT_STORES_START';
export const RECENT_STORES_ERROR = 'RECENT_STORES_ERROR';
export const RECENT_STORES_SUCCESS = 'RECENT_STORES_SUCCESS';
